/**
 * A KUPAC ÜGYFELENKÉNT (#68, a „B" elrendezés, Viktor 2026-10-19).
 *
 * Több cégnél egy pillantásra látszik, kinek mennyi papírja vár. Tiszta
 * függvény, React nélkül: a CSOPORTOSÍTOTT SORREND a sor-mód sorrendje is.
 *
 * ⚠️ A CSOPORTOSÍTÁS A HOROGBAN TÖRTÉNIK, nem a rajzoláskor. A `J`/`K` és az
 * `Enter` utáni továbblépés a `visible` sorrendjén jár; ha csak a felület
 * rendezné cégekbe a sorokat, a kurzor a képernyőn össze-vissza ugrálna —
 * egy cég utolsó sorából egy másik cég közepére.
 *
 * A SORREND STABIL. A csoportok abban a sorrendben jönnek, ahogy a cégük
 * ELŐSZÖR feltűnik a listában, és a csoporton belül a szerver sorrendje
 * marad. Így ahol a lista eddig is cégenként állt, ott semmi nem mozdul.
 */

import type { WorklistItem } from './types';

export interface QueueGroup {
  companyId: string;
  companyName: string;
  items: WorklistItem[];
}

export function groupByCompany(items: readonly WorklistItem[]): QueueGroup[] {
  const groups = new Map<string, QueueGroup>();
  for (const item of items) {
    const group = groups.get(item.companyId);
    if (group === undefined) {
      groups.set(item.companyId, {
        companyId: item.companyId,
        companyName: item.companyName,
        items: [item],
      });
    } else {
      group.items.push(item);
    }
  }
  return [...groups.values()];
}
